import { COVER_CROP_MIX_TYPE, CoverCropMixType, SOIL_SIGHT_TILLAGE, SoilSightTillage } from "consts";

import { CropYear } from "pages/app/scenario-analysis/types/scenario";

export type ScenarioResilienceInput = {
  scenarioId: string;
  cropRotation: {
    cropId: string;
    tillageId: SoilSightTillage;
    coverCropId: CoverCropMixType;
    residue: boolean | null;
  }[];
};

export type ScenarioResilienceBreakdown = {
  biodiversity: number;
  soilHealth: number;
  waterCapacity: number;
};

/** optional rotation extras — API may lag a deploy, so Partial on the result. */
export type ScenarioRotationMetrics = {
  cropsInRotation: number;
  plantFamilies: number;
  soilCoverScore: number; // 0–10, tile shows ×10 as %
  coverCropSharePercent: number;
};

export type ScenarioResilienceResult = {
  scenarioId: string;
  baseScore: number;
  yearlyScores: number[];
  breakdown: ScenarioResilienceBreakdown;
} & Partial<ScenarioRotationMetrics>;

export type ScenarioResilienceByScenarioId = Record<string, ScenarioResilienceResult>;

const isFiniteNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);

/** all four finite? then show the tiles. else shrug and hide. */
export function hasRotationMetrics(result: ScenarioResilienceResult): result is ScenarioResilienceResult & ScenarioRotationMetrics {
  return (
    isFiniteNumber(result.cropsInRotation) &&
    isFiniteNumber(result.plantFamilies) &&
    isFiniteNumber(result.soilCoverScore) &&
    isFiniteNumber(result.coverCropSharePercent)
  );
}

/** Maps a CropYear to the resilience API input shape. Only years with a main crop are included. */
export function buildResilienceInputFromYears(scenarioId: string, years: CropYear[]): ScenarioResilienceInput {
  return {
    scenarioId,
    cropRotation: years
      .filter((y) => !!y.crop)
      .map((y) => ({
        cropId: y.crop,
        tillageId: y.tillageId ?? SOIL_SIGHT_TILLAGE.NONE,
        coverCropId: y.coverCropId ?? COVER_CROP_MIX_TYPE.NONE,
        residue: y.residue ?? null,
      })),
  };
}
